var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Navbar'),_c('v-main',{staticClass:"grey lighten-5",class:_vm.$vuetify.breakpoint.mdAndUp ? 'mt-15' : '',staticStyle:{"padding":"10px 0px 0px !important"}},[(!_vm.$vuetify.breakpoint.lgAndUp)?_c('BottomNavigation'):_vm._e(),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }